<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      orders: [],
      ordersLoading: true,
    };
  },
  methods: {
    getOrders() {
      this.ordersLoading = true;
      this.orders = [];

      api
        .get("consultas/orders")
        .then((response) => {
          if (response.data.status == "success" && Array.isArray(response.data.list)) {
            this.orders = response.data.list;
          } else {
            this.orders = [];
          }
        })
        .catch(() => {
          this.orders = [];
        })
        .finally(() => {
          this.ordersLoading = false;
        });
    },
  },
  mounted() {
    this.getOrders();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/consultas">Consultas</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">Meus Pedidos</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Meus Pedidos</h3>
        <p></p>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="ordersLoading" class="consulta-orders-skeleton table-responsive" aria-hidden="true">
          <table class="table table-centered table-nowrap mb-0">
            <thead class="thead-light">
              <tr>
                <th style="width: 56px">
                  <div class="cos-sk-line cos-sk-w-50" style="height: 12px"></div>
                </th>
                <th style="width: 120px">
                  <div class="cos-sk-line cos-sk-w-70" style="height: 12px"></div>
                </th>
                <th>
                  <div class="cos-sk-line cos-sk-w-40" style="height: 12px"></div>
                </th>
                <th style="width: 100px">
                  <div class="cos-sk-line cos-sk-w-65" style="height: 12px"></div>
                </th>
                <th style="width: 110px">
                  <div class="cos-sk-line cos-sk-w-85" style="height: 12px"></div>
                </th>
                <th class="text-right" style="width: 100px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="n in 6" :key="'ord-sk-' + n">
                <td><div class="cos-sk-line cos-sk-w-70" style="height: 14px"></div></td>
                <td><div class="cos-sk-line cos-sk-w-90" style="height: 14px"></div></td>
                <td>
                  <div class="cos-sk-line cos-sk-w-80 mb-1" style="height: 12px"></div>
                  <div class="cos-sk-line cos-sk-w-50" style="height: 10px"></div>
                </td>
                <td><div class="cos-sk-line cos-sk-w-60" style="height: 14px"></div></td>
                <td><div class="cos-sk-badge"></div></td>
                <td class="text-right"><div class="cos-sk-pill ml-auto"></div></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          v-else-if="orders.length === 0"
          class="min-vh-25 text-center d-flex justify-content-center align-items-center"
        >
          <div>
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhum registro encontrado
          </div>
        </div>

        <div v-else class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Data</th>
                <th>Tipo</th>
                <th>Valor</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in orders" :key="row.id">
                <td>{{ row.id }}</td>
                <td>{{ row.date }}</td>
                <td>{{ row.service_name || row.package }}</td>
                <td>{{ row.value | currency }}</td>
                <td>
                  <span class="badge badge-soft-danger font-size-13" v-if="row.status == 'pending'">PENDENTE</span>
                  <span class="badge badge-soft-success font-size-13" v-else-if="row.status == 'approved'">APROVADO</span>
                  <span class="badge badge-soft-warning font-size-13" v-else-if="row.status == 'canceled'">CANCELADO</span>
                </td>
                <td class="text-right">
                  <router-link v-if="row.status == 'pending'" :to="'/consultas/pedidos/' + row.id" class="btn btn-default btn-sm btn-rounded">
                    Pagar
                    <i class="mdi mdi-arrow-right ml-1"></i>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped lang="scss">
.consulta-orders-skeleton .cos-sk-line,
.consulta-orders-skeleton .cos-sk-pill,
.consulta-orders-skeleton .cos-sk-badge {
  background: linear-gradient(
    90deg,
    #e8e8e8 25%,
    #f5f5f5 50%,
    #e8e8e8 75%
  );
  background-size: 200% 100%;
  animation: consulta-orders-skeleton-shimmer 1.4s infinite ease-in-out;
  border-radius: 4px;
}

.consulta-orders-skeleton .cos-sk-pill {
  width: 72px;
  height: 31px;
  border-radius: 4px;
}

.consulta-orders-skeleton .cos-sk-badge {
  width: 88px;
  height: 22px;
  border-radius: 4px;
}

.consulta-orders-skeleton .cos-sk-w-40 {
  width: 40%;
}

.consulta-orders-skeleton .cos-sk-w-50 {
  width: 50%;
}

.consulta-orders-skeleton .cos-sk-w-60 {
  width: 60%;
}

.consulta-orders-skeleton .cos-sk-w-65 {
  width: 65%;
}

.consulta-orders-skeleton .cos-sk-w-70 {
  width: 70%;
}

.consulta-orders-skeleton .cos-sk-w-80 {
  width: 80%;
}

.consulta-orders-skeleton .cos-sk-w-85 {
  width: 85%;
}

.consulta-orders-skeleton .cos-sk-w-90 {
  width: 90%;
}

@keyframes consulta-orders-skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

body[data-sidebar="dark"] .consulta-orders-skeleton .cos-sk-line,
body[data-sidebar="dark"] .consulta-orders-skeleton .cos-sk-pill,
body[data-sidebar="dark"] .consulta-orders-skeleton .cos-sk-badge {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.08) 25%,
    rgba(255, 255, 255, 0.14) 50%,
    rgba(255, 255, 255, 0.08) 75%
  );
  background-size: 200% 100%;
}
</style>
